import React, { useState, useEffect } from 'react';
import { Box, Paper, styled, Typography, CircularProgress, Alert } from '@mui/material';
import ManagerSidebar from './ManagerSidebar';
// Gerçek sayfaları import et
import Tasks from '../tasks/Tasks';
import Personnel from '../personnel/Personnel';
import Shifts from '../vardiya/Shifts';
import Reports from '../reports/Reports';
import Messages from '../messages/Messages';
import SinglePersonMessage from '../messages/SinglePersonMessage';
import Surveys from '../../pages/Surveys';
import ActualDashboard from '../dashboard/Dashboard';
import QRMenuPage from '../qr-menu/QRMenuPage';
import KitchenScreen from '../kitchen/KitchenScreen';
import OrdersPage from '../qr-menu/components/OrdersPage';
import CustomersPage from '../qr-menu/components/CustomersPage';
import TablesPage from '../qr-menu/components/TablesPage';
import EndOfDayReport from '../reports/EndOfDayReport'; // ✅ YENİ: Satış Raporları
import EndOfDayReportsList from '../reports/EndOfDayReportsList'; // ✅ YENİ: Gün Sonları Listesi
import AccountingDashboard from '../accounting/dashboard/Dashboard';
import Invoice from '../accounting/invoice/Invoice';
import EInvoice from '../accounting/e-invoice/E-Invoice';
import BranchPrices from '../accounting/branchPrices/BranchPrices';
import Accounts from '../accounting/accounts/Accounts';
import Bank from '../accounting/bank/Bank';
import Cashbox from '../accounting/cashbox/Cashbox';
import InterCompanyB2B from '../accounting/intercompany/InterCompanyB2B';
import { useAuth } from '../../contexts/AuthContext';
import firebaseDataService from '../../services/FirebaseDataService';
import { useNavigate } from 'react-router-dom';
import { mainApi } from '../../config/apiClient';

// Manager için KitchenScreen wrapper component'i
const ManagerKitchenScreen: React.FC<{ branchId?: string }> = ({ branchId }) => {
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);
  const [menuId, setMenuId] = useState<string | null>(null);
  const { currentUser } = useAuth();
  const navigate = useNavigate();

  // Manager'ın şubesindeki ilk menüyü bul
  useEffect(() => {
    const fetchManagerMenu = async () => {
      console.log('🔍 ManagerKitchenScreen başlatılıyor:', { currentUser: !!currentUser, branchId });
      
      if (!currentUser || !branchId) {
        console.log('❌ Eksik bilgi:', { currentUser: !!currentUser, branchId });
        setError('Şube bilgisi bulunamadı.');
        setLoading(false);
        return;
      }

      try {
        // Kullanıcının şirket ID'sini al
        console.log('🔍 Firebase kullanıcı bilgisi alınıyor:', currentUser.uid);
        const userData = await firebaseDataService.getUserData(currentUser.uid);
        
        if (!userData) {
          console.log('❌ Firebase kullanıcı bilgisi bulunamadı');
          setError('Kullanıcı bilgisi bulunamadı.');
          setLoading(false);
          return;
        }

        const companyId = userData.companyId;
        console.log('✅ Kullanıcı bilgisi alındı:', { companyId, role: userData.role });

        // Şirketin QR menülerini al
        console.log('🔍 QR menüleri API çağrısı yapılıyor...');
        const response = await mainApi.get(`/api/QRMenu/menu-definitions`);
        
        console.log('📡 API yanıtı:', { status: response.status });
        
        const result = response.data;
        console.log('📋 API sonucu:', { success: result.success, dataLength: result.data?.length });
        
        if (result.success && result.data) {
          // Manager'ın şubesine ait menüleri filtrele
          console.log('🔍 Menüler filtreleniyor. BranchId:', branchId);
          console.log('📋 Tüm menüler:', result.data.map((m: any) => ({ id: m.id, name: m.name, branchId: m.branchId })));
          
          const branchMenus = result.data.filter((menu: any) => menu.branchId === branchId);
          console.log('✅ Filtrelenmiş menüler:', branchMenus);
          
          if (branchMenus.length > 0) {
            // İlk menüyü seç ve doğrudan mutfak ekranına yönlendir
            const selectedMenuId = branchMenus[0].id;
            console.log(`✅ Manager mutfak ekranı için menü seçildi: ${branchMenus[0].name} (${selectedMenuId})`);
            console.log(`🔄 Mutfak ekranına yönlendiriliyor: /qr-menu/${selectedMenuId}/kitchen`);
            navigate(`/qr-menu/${selectedMenuId}/kitchen`, { 
              state: { fromManager: true }
            });
            return;
          } else {
            console.log('❌ Bu şubeye ait menü bulunamadı');
            setError('Bu şubeye ait QR menü bulunamadı.');
          }
        } else {
          console.log('❌ API başarısız veya data yok:', result);
          setError('QR menü bilgileri alınamadı.');
        }
      } catch (error) {
        console.error('❌ Manager menü yükleme hatası:', error);
        setError('Menü bilgileri yüklenirken hata oluştu.');
      } finally {
        setLoading(false);
      }
    };

    fetchManagerMenu();
  }, [currentUser, branchId]);

  if (loading) {
    return (
      <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '50vh' }}>
        <CircularProgress />
      </Box>
    );
  }

  if (error) {
    return (
      <Box sx={{ p: 3 }}>
        <Alert severity="error">{error}</Alert>
      </Box>
    );
  }

  // Bu component sadece yönlendirme yapar, render edilmez
  return null;
};

// İçerik alanını stilize et
const ContentContainer = styled(Box)<{ sidebarWidth: number }>(({ theme, sidebarWidth }) => ({
  flexGrow: 1,
  height: '100%',
  marginLeft: 0,
  width: `calc(100% - ${sidebarWidth}px)`, // Sadece sidebar genişliği
  transition: theme.transitions.create(['width', 'margin'], {
    easing: theme.transitions.easing.sharp,
    duration: theme.transitions.duration.enteringScreen,
  }),
  overflowY: 'auto',
}));

// Ana konteyner
const MainContainer = styled(Box)(({ theme }) => ({
  display: 'flex',
  width: '100%',
  height: '100%', // ✅ 100vh yerine 100% - üst kapsayıcı zaten calc(100vh - 64px) ayarlı
  backgroundColor: 'transparent',
  overflow: 'hidden',
}));

// BranchSurveys bileşeni tipi için detaylı tanımlama
interface UserDetails {
  branchesId?: string;
  companyId?: string;
  [key: string]: any;
}

interface ManagerWithSidebarProps {
  activeBranchId: string | null;
  branchesLoading?: boolean;
}

// Şube görevlerini filtreleme bileşeni
const BranchTasks: React.FC<{ activeBranchId: string | null }> = ({ activeBranchId }) => {
  // const { userDetails } = useAuth(); // Artık userDetails'e gerek yok, prop ile geliyor
  
  if (activeBranchId) {
    return <Tasks branchId={activeBranchId} isManager={true} />;
  }
  // Aktif şube yoksa (veya manager'ın hiç şubesi yoksa) ne gösterilecek?
  // Belki bir mesaj veya boş bir Tasks bileşeni.
  // Şimdilik null dönüyoruz veya bir uyarı mesajı gösterebiliriz.
  return <Typography sx={{p:2}}>Lütfen görüntülenecek bir şube seçin.</Typography>; 
};

// Şube personelini filtreleme bileşeni
const BranchPersonnel: React.FC<{ activeBranchId: string | null }> = ({ activeBranchId }) => {
  // const { userDetails } = useAuth();
  
  if (activeBranchId) {
    console.log("Personel görüntüleniyor, aktif şube ID:", activeBranchId);
    return <Personnel branchId={activeBranchId} isManager={true} />;
  }
  return <Typography sx={{p:2}}>Lütfen görüntülenecek bir şube seçin.</Typography>; 
};

// Şube vardiyalarını filtreleme bileşeni
const BranchShifts: React.FC<{ activeBranchId: string | null }> = ({ activeBranchId }) => {
  // const { userDetails } = useAuth();
  
  if (activeBranchId) {
    console.log("Vardiya görüntüleniyor, aktif şube ID:", activeBranchId);
    return <Shifts branchId={activeBranchId} isManager={true} />;
  }
  return <Typography sx={{p:2}}>Lütfen görüntülenecek bir şube seçin.</Typography>; 
};

// Şube raporlarını filtreleme bileşeni
const BranchReports: React.FC<{ activeBranchId: string | null }> = ({ activeBranchId }) => {
  // const { userDetails } = useAuth();
  
  if (activeBranchId) {
    console.log("Rapor görüntüleniyor, aktif şube ID:", activeBranchId);
    return <Reports branchId={activeBranchId} isManager={true} />;
  }
  return <Typography sx={{p:2}}>Lütfen görüntülenecek bir şube seçin.</Typography>; 
};

// Şube mesajlarını filtreleme bileşeni
const BranchMessages: React.FC<{ userDetails: UserDetails | null, activeBranchId: string | null }> = ({ userDetails, activeBranchId }) => {
  // userDetails hala genel mesajlaşma özellikleri için gerekli olabilir, aktif şube mesajları filtrelemek için activeBranchId kullanılır
  if (activeBranchId) {
    return <Messages isManager={true} branchId={activeBranchId} />;
  }
  return <Typography sx={{p:2}}>Lütfen görüntülenecek bir şube seçin.</Typography>; 
};

// Şube anketlerini filtreleme bileşeni
const BranchSurveys: React.FC<{ userDetails: UserDetails | null, activeBranchId: string | null }> = ({ userDetails, activeBranchId }) => {
  // userDetails genel anket özellikleri için gerekli olabilir, aktif şube anketleri filtrelemek için activeBranchId kullanılır
  if (activeBranchId) {
    return <Surveys isManager={true} branchId={activeBranchId} />;
  }
  return <Typography sx={{p:2}}>Lütfen görüntülenecek bir şube seçin.</Typography>; 
};

const ManagerWithSidebar: React.FC<ManagerWithSidebarProps> = ({ activeBranchId, branchesLoading }) => {
  const [activeTab, setActiveTab] = useState<string>('dashboard');
  const [sidebarWidth, setSidebarWidth] = useState(260);
  const { userDetails } = useAuth(); // BranchMessages ve BranchSurveys için hala gerekli olabilir

  // Tab değişikliğini handle et
  const handleTabChange = (tabId: string) => {
    setActiveTab(tabId);
  };

  // Sidebar daraltma/genişletmeyi handle et
  const handleSidebarCollapse = (isCollapsed: boolean) => {
    setSidebarWidth(isCollapsed ? 70 : 260);
  };

  // QR Menü sayfaları arası navigasyon
  const handleQRMenuNavigation = (page: string) => {
    setActiveTab(page);
  };

  // Aktif tab'a göre bileşeni render et
  const renderActiveComponent = () => {
    switch (activeTab) {
      case 'dashboard':
        if (activeBranchId) {
          return <ActualDashboard branchId={activeBranchId} isManager={true} />;
        }
        return <Typography sx={{p:2}}>Lütfen görüntülenecek bir şube seçin.</Typography>; 
      case 'tasks':
        return <BranchTasks activeBranchId={activeBranchId} />;
      case 'personnel':
        return <BranchPersonnel activeBranchId={activeBranchId} />;
      case 'shifts':
        return <BranchShifts activeBranchId={activeBranchId} />;
      case 'reports':
        return <BranchReports activeBranchId={activeBranchId} />;
      case 'messages':
        return <BranchMessages userDetails={userDetails} activeBranchId={activeBranchId} />;
      case 'surveys':
        return <BranchSurveys userDetails={userDetails} activeBranchId={activeBranchId} />;
      case 'qrmenu':
        return <QRMenuPage branchId={activeBranchId || undefined} isManager={true} onNavigate={handleQRMenuNavigation} />;
      case 'qrmenu-kitchen':
        // Manager için özel KitchenScreen wrapper'ı - ilk menüyü otomatik seç
        return <ManagerKitchenScreen branchId={activeBranchId || undefined} />;
      case 'qrmenu-orders':
        return <OrdersPage isManager={true} onNavigateBack={() => setActiveTab('qrmenu')} branchId={activeBranchId || undefined} />;
      case 'qrmenu-customers':
        return <CustomersPage isManager={true} onNavigateBack={() => setActiveTab('qrmenu')} />;
      case 'qrmenu-tables':
        return <TablesPage isManager={true} onNavigateBack={() => setActiveTab('qrmenu')} branchId={activeBranchId || undefined} />;
      case 'salesReports':
        // ✅ YENİ: Satış Raporları - Şube otomatik seçili ve kilitli
        if (activeBranchId) {
          return <EndOfDayReport isManager={true} managerBranchId={activeBranchId} />;
        }
        return <Typography sx={{p:2}}>Lütfen görüntülenecek bir şube seçin.</Typography>;
      case 'endOfDayList':
        // ✅ YENİ: Gün Sonları Listesi - Şube otomatik seçili ve kilitli
        if (activeBranchId) {
          return <EndOfDayReportsList isManager={true} managerBranchId={activeBranchId} />;
        }
        return <Typography sx={{p:2}}>Lütfen görüntülenecek bir şube seçin.</Typography>;
      case 'accountingDashboard':
        if (activeBranchId) {
          return <AccountingDashboard isManager={true} branchId={activeBranchId} />;
        }
        return <Typography sx={{p:2}}>Lütfen görüntülenecek bir şube seçin.</Typography>;
      case 'invoices':
        if (activeBranchId) {
          return <Invoice isManager={true} managerBranchId={activeBranchId} />;
        }
        return <Typography sx={{p:2}}>Lütfen görüntülenecek bir şube seçin.</Typography>;
      case 'eInvoices':
        if (activeBranchId) {
          return <EInvoice isManager={true} managerBranchId={activeBranchId} />;
        }
        return <Typography sx={{p:2}}>Lütfen görüntülenecek bir şube seçin.</Typography>;
      case 'branchPrices':
        if (activeBranchId) {
          return <BranchPrices isManager={true} managerBranchId={activeBranchId} />;
        }
        return <Typography sx={{p:2}}>Lütfen görüntülenecek bir şube seçin.</Typography>;
      case 'current':
        if (activeBranchId) {
          return <Accounts isManager={true} managerBranchId={activeBranchId} />;
        }
        return <Typography sx={{p:2}}>Lütfen görüntülenecek bir şube seçin.</Typography>;
      case 'bank':
        if (activeBranchId) {
          return <Bank isManager={true} managerBranchId={activeBranchId} />;
        }
        return <Typography sx={{p:2}}>Lütfen görüntülenecek bir şube seçin.</Typography>;
      case 'cash':
        if (activeBranchId) {
          return <Cashbox isManager={true} managerBranchId={activeBranchId} />;
        }
        return <Typography sx={{p:2}}>Lütfen görüntülenecek bir şube seçin.</Typography>;
      case 'orders':
        // B2B siparişleri: şube kendi adına kod alır, yalnız kendi gelen siparişlerini görür
        if (activeBranchId) {
          return <InterCompanyB2B isManager={true} managerBranchId={activeBranchId} />;
        }
        return <Typography sx={{p:2}}>Lütfen görüntülenecek bir şube seçin.</Typography>;
      default:
        return <div>Sayfa Bulunamadı</div>;
    }
  };

  return (
    <MainContainer>
      <ManagerSidebar
        activeBranchId={activeBranchId}
        branchesLoading={branchesLoading}
        onTabChange={handleTabChange}
        onCollapse={handleSidebarCollapse}
      />
      
      <ContentContainer sidebarWidth={sidebarWidth}>
        {renderActiveComponent()}
      </ContentContainer>
    </MainContainer>
  );
};

export default ManagerWithSidebar; 